import src from "IMAGE";
export default { src, width: 495, height: 81, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AHQqAG1DMig/kJCQiY6OjomDg4N+jIyMhUI6NT0tEAAhzOUL0JSGDVkAAAAASUVORK5CYII="};
